import React from 'react';
import IntegrationDocTemplate from '../../../../components/IntegrationDocTemplate';

export default function DocsShipBob() {
  return (
    <IntegrationDocTemplate
      title="ShipBob"
      category="Warehousing · 3PL"
      status="live"
      summary="ShipBob 2026-01 REST API. Distributed US fulfillment network. Pay-per-unit. Modern developer experience with free sandbox. Best for D2C brands at 100-50K orders/month."
      prerequisites={[
        'ShipBob account (apply at shipbob.com).',
        'API token from ShipBob dashboard → Integrations → Developer.',
        'shipbob_channel_id from your channel setup.',
      ]}
      connectSteps={[
        'Text us "ShipBob" with your phone number.',
        'Paste your API token + channel ID.',
        'First sync: existing inventory + bundles + receiving records.',
        'Outbound orders route automatically to ShipBob from our order_router_agent.',
      ]}
      syncedData={[
        { type: 'Orders', detail: 'CI → ShipBob: create_order with line items + ship address' },
        { type: 'Order status', detail: 'ShipBob → CI: real-time fulfillment status updates' },
        { type: 'Inventory', detail: 'Per-SKU On-Hand, Fulfillable, Sellable across all ShipBob FCs' },
        { type: 'Receiving', detail: 'Inbound shipment tracking + receiving confirmations' },
        { type: 'Returns', detail: 'Customer returns initiated + processed' },
      ]}
      agents={[
        { id: 'rfq_agent', name: 'rfq_agent', role: 'Seller-side RFQ flow if you found ShipBob via our marketplace' },
        { id: 'order_router_agent', name: 'order_router_agent', role: 'Decides which 3PL gets which order based on cost/speed/SLA' },
        { id: 'three_pl_compliance_agent', name: 'three_pl_compliance_agent', role: 'Monitors ShipBob SLA performance daily' },
      ]}
      troubleshooting={[
        { question: 'Reference ID conflict', answer: 'ShipBob requires reference_id to be unique within your account. Our adapter uses ci_order_id which is globally unique.' },
        { question: 'Order stuck in "received" state', answer: 'Check that your inventory is allocated to the correct fulfillment center. Use the ShipBob dashboard to verify; reach out to ShipBob if inventory is missing.' },
      ]}
      supportLink="/contact"
    />
  );
}
